/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type Locale } from '@/types/i18n';
import { type ParsedUrlQuery } from 'querystring';
import { BLOG_POST_ROUTE, BLOG_REVIEWERS_ROUTE } from '../constants';
import { blogPrefix } from './isValidBlogLocale';

type BlogPathResult = {
  blogPageType: 'post' | 'reviewer';
  fullPath: string;
};

export const getBlogPath = (
  locale: Locale,
  query: ParsedUrlQuery & { blogPath?: string[]; reviewersPath?: string[] },
  pathname: string,
): BlogPathResult => {
  const blogRoot = blogPrefix[locale];

  let blogPageType: 'post' | 'reviewer';
  let fullPath: string;

  if (pathname === BLOG_REVIEWERS_ROUTE) {
    blogPageType = 'reviewer';
    const reviewersPath = query.reviewersPath ?? [];
    fullPath = `${blogRoot}/reviewers/${reviewersPath.join('/')}`;
  } else if (pathname === BLOG_POST_ROUTE) {
    blogPageType = 'post';
    const postPath = query.blogPath ?? [];
    fullPath = `${blogRoot}/${postPath.join('/')}`;
  } else {
    // default to blog home
    blogPageType = 'post';
    fullPath = `${blogRoot}/`;
  }

  return {
    blogPageType,
    fullPath,
  };
};
